var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-edit-small.9b070383.png","uri@2x": __webpack_public_path__ + "icon-edit-small.aa12c4dd.png","uri@3x": __webpack_public_path__ + "icon-edit-small.9c2d0ff4.png",
    width: 17,
    height: 17
});